'use client';

import { createStore } from 'zustand';

import { CartClearReason } from '@/types/cart-clear-confirmation.types';

export type CartClearConfirmationState = {
  isOpen: boolean;
  reason: CartClearReason | null;
};

const initialState: CartClearConfirmationState = {
  isOpen: false,
  reason: null,
};

export const cartClearConfirmationStore = createStore<CartClearConfirmationState>(() => ({ ...initialState }));

let pendingAnswer: ((confirmed: boolean) => void) | null = null;

const answer = (confirmed: boolean) => {
  const respond = pendingAnswer;

  pendingAnswer = null;
  cartClearConfirmationStore.setState({ ...initialState });
  respond?.(confirmed);
};

export const openCartClearConfirmation = (reason: CartClearReason): Promise<boolean> => {
  answer(false);

  return new Promise<boolean>((resolve) => {
    pendingAnswer = resolve;
    cartClearConfirmationStore.setState({ isOpen: true, reason });
  });
};

export const confirmCartClearConfirmation = () => answer(true);

export const cancelCartClearConfirmation = () => answer(false);
